module.exports = __webpack_public_path__ + "img/logo.84fbe2ac.png";